import React, { createContext, useContext, useEffect, useState } from "react";
import { getSite } from "@/lib/api";

const defaults = {
    about_paragraphs: [
        "Depmont is an independent creative company. We design identities, editorial systems and digital experiences for founders and organisations building for the long term.",
        "Our practice is small by intention. We take on a limited number of engagements each year, which allows us to work closely, think deeply and deliver work we can stand behind for the decades that follow it.",
        "We do not measure ourselves in awards or years of experience. We measure ourselves by whether the work still feels correct a decade from now — and by whether it earned the right to exist in the first place.",
    ],
    contact_email: "contact@depmont.com",
    // Social links are left empty on purpose. These are shown before /api/site
    // responds, and the studio's real profiles live in the database — hardcoding
    // them here means two copies that drift. An empty value simply renders no
    // icon for the moment before the real one arrives.
    linkedin_url: "",
    instagram_url: "",
    x_url: "",
};

const SiteCtx = createContext(defaults);

export function SiteProvider({ children }) {
    const [site, setSite] = useState(defaults);
    useEffect(() => {
        getSite()
            .then((d) => setSite({ ...defaults, ...d }))
            .catch(() => {});
    }, []);
    return <SiteCtx.Provider value={site}>{children}</SiteCtx.Provider>;
}

export const useSite = () => useContext(SiteCtx);
